/* ==========================================================================
   Vertrauens-Block: zeigt bei jedem Seitenaufruf eine andere echte Kundenmeinung aus Fera.
   - Produktseite: bevorzugt eine Meinung zu genau diesem Produkt.
   - Kollektionsseite: bevorzugt eine Meinung zu einem Produkt aus dieser Kollektion.
   - Sonst: eine allgemeine Shop-Bewertung (nicht an ein Produkt gebunden).
   - Nur 5 Sterne, nur Texte mit passender Länge (gut lesbar im Block).
   - Die Liste wird pro Browser-Sitzung einmal geladen (sessionStorage), danach nur neu gewürfelt.
   - Klappt etwas nicht, bleibt das Zitat aus dem HTML stehen.
   ========================================================================== */
(function () {
  var KEY = 'pk_fa78d17236253efa8418bf77762e29c7a76ca471558e34180e13bbb8319ad8c5';
  var API = 'https://api.fera.ai/v2/public/reviews.json?public_key=' + KEY + '&limit=100';
  var MIN = 50, MAX = 240;

  function passend(r) {
    var t = (r.body || '').trim();
    return r.rating >= 5 && t.length >= MIN && t.length <= MAX;
  }

  function schlank(r) {
    return {
      t: (r.body || '').trim().replace(/\s+/g, ' '),
      n: r.customer_name || '',
      p: r.product ? r.product.name : '',
      u: r.product && r.product.url ? r.product.url : ''
    };
  }

  function laden(url, cacheKey) {
    try {
      var c = sessionStorage.getItem(cacheKey);
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}
    return fetch(url).then(function (res) { return res.json(); }).then(function (d) {
      var liste = (Array.isArray(d) ? d : []).filter(passend).map(schlank);
      try { sessionStorage.setItem(cacheKey, JSON.stringify(liste)); } catch (e) {}
      return liste;
    });
  }

  function alle() {
    // Allgemeine Shop-Bewertungen aus den neuesten 300 – reicht für viel Abwechslung.
    var seiten = [1, 2, 3].map(function (s) { return API + '&page=' + s; });
    try {
      var c = sessionStorage.getItem('vb-alle');
      if (c) return Promise.resolve(JSON.parse(c));
    } catch (e) {}
    return Promise.all(seiten.map(function (u) { return fetch(u).then(function (r) { return r.json(); }).catch(function () { return []; }); }))
      .then(function (teile) {
        var liste = [].concat.apply([], teile).filter(function (r) { return passend(r) && !r.product; }).map(schlank);
        try { sessionStorage.setItem('vb-alle', JSON.stringify(liste)); } catch (e) {}
        return liste;
      });
  }

  function zeigen(box, r) {
    var text = box.querySelector('[data-vb-text]');
    var name = box.querySelector('[data-vb-name]');
    if (!text || !name || !r) return;
    box.classList.add('is-laden');
    setTimeout(function () {
      text.textContent = '„' + r.t + '“';
      var mitLink = r.p && r.u && !box.dataset.vbProdukt;
      name.textContent = '— ' + r.n + (mitLink ? ' über ' : '');
      if (mitLink) {
        var a = document.createElement('a');
        a.href = r.u.replace(/^https?:\/\/[^/]+/, '');
        a.textContent = r.p.replace(/&amp;/g, '&').split(' | ')[0];
        name.appendChild(a);
      }
      box.classList.remove('is-laden');
    }, 300);
  }

  function zufall(liste) { return liste[Math.floor(Math.random() * liste.length)]; }

  function start() {
    var boxen = document.querySelectorAll('[data-vb-zitat]');
    if (!boxen.length || !window.fetch) return;
    Array.prototype.forEach.call(boxen, function (box) {
      if (box.dataset.vbFertig) return;
      box.dataset.vbFertig = '1';
      var pid = box.dataset.vbProdukt;
      var pids = (box.dataset.vbProdukte || '').split(',').filter(Boolean).slice(0, 50).join(',');
      var weg;
      if (pid) weg = laden(API + '&product_id=' + pid, 'vb-p-' + pid);
      else if (pids) weg = laden(API + '&product_ids=' + pids, 'vb-k-' + location.pathname);
      else weg = Promise.resolve([]);
      weg = weg.then(function (l) { return l.length ? l : alle(); });
      weg.then(function (l) { if (l.length) zeigen(box, zufall(l)); }).catch(function () {});
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start);
  else start();
})();
